import { render, staticRenderFns } from "./RecievedPerWeek.vue?vue&type=template&id=ee63cf16&"
import script from "./RecievedPerWeek.vue?vue&type=script&lang=js&"
export * from "./RecievedPerWeek.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports